<div fxFlex id="video">
  <iframe width="100%" height="200" frameborder="0" [src]="displayURL"></iframe>

  <h2>{{ description }}</h2>
</div>
